import { Record as record } from 'immutable';
import _ from 'lodash';

import t from '../../../../lib/I18n';
import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, fields } from '../../../../helpers/LinkMapper';

import JourneyPattern from './JourneyPattern';

const fieldSchema = {
    "transactionId": [resolve.with(Number)],
    "description": [resolve.with(String)],
    "timestamp": [resolve.with(trainTime)],
    "type": [resolve.with(String)],
    "value": [resolve.with(Number)],
    "balance": [resolve.with(Number)],
    "status": [resolve.with(String)],
    "journeyPattern": [resolve.as(JourneyPattern)],
    "reasonDescription": [fields.string],
    "reasonCode": [fields.string]
};

const actOnEachWord = (string, func) => string.split(' ').map(str => func(str)).join(' ');

const capitalizeAsTitle = (str) => {
    if (/^(for|on)$/.test(str.toLowerCase())) {
        return str;
    }
    return _.capitalize(str);
};

class Transaction extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        const returnVal = construct(Transaction, json, getResolvers(fieldSchema));
        return returnVal;
    }

    isParsedTransaction () {
        return this.reasonDescription && this.reasonCode;
    }

    isBalanceAdjustment () {
        return this.isParsedTransaction() && /\|\|\|/.test(this.reasonDescription);
    }

    isReimbursement () {
        return this.isParsedTransaction() && !/\|\|\|/.test(this.reasonDescription);
    }

    parseAdjustedTransactionDescription () {
        return this.reasonDescription.replace(/.*\|\|\|/, '');
    }

    parseAdjustedTransactionReason () {
        return this.reasonDescription.split(/\|\|\|/)[0];
    }

    getDescription () {
        if (this.isBalanceAdjustment()) {
            return actOnEachWord(this.parseAdjustedTransactionDescription(), capitalizeAsTitle);
        }
        if (this.isReimbursement()) {
            return t('account.smartcard.keygo.reimbursement.description');
        }
        return actOnEachWord(this.description, _.capitalize);
    }

    getType () {
        if (this.isBalanceAdjustment()) {
            return t(`account.smartcard.keygo.balanceAdjustmentCode.${this.reasonCode}`);
        }
        if (this.isReimbursement()) {
            return t(`account.smartcard.keygo.manualRefundCode.${this.reasonCode}`);
        }
        return this.type.toLowerCase();
    }
}

export default Transaction;



// WEBPACK FOOTER //
// ./src/records/customer/keygo/journeyHistory/Transaction.js